// extracted by mini-css-extract-plugin
export default {"btnpwd":"bbf38bbc9b"};